import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-route-plan-edit',
    templateUrl: './route-plan-edit.component.html',
    styleUrls: ['./route-plan-edit.component.scss'],
    standalone: false
})
export class RoutePlanEditComponent implements OnInit {
  constructor() {}

  public ngOnInit() {}
}
